(() => {
  if (customElements.get('stellar-product-routine')) return;
  customElements.define('stellar-product-routine', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      if (this.hasAttribute('data-routine-width-content')) {
        let mapping;
        try { mapping = JSON.parse(this.querySelector('[data-routine-width-variants]')?.textContent || '{}'); } catch (_) { return; }
        const all = new Set((mapping.all || []).map(String));
        const matching = new Set((mapping.matching || []).map(String));
        const template = this.querySelector('template[data-routine-width-template]');
        this.currentVariant = this.dataset.routineCurrentVariant;
        this.events = new AbortController();
        document.addEventListener('change', event => {
          if (!event.target.matches('form[id^="product-form-"] input[name="id"]')) return;
          const variant = String(event.target.value);
          if (!all.has(variant) || variant === this.currentVariant) return;
          this.currentVariant = variant;
          this.dataset.routineCurrentVariant = variant;
          const current = this.querySelector(':scope > section');
          if (!matching.has(variant)) {
            current?.querySelectorAll('video').forEach(video => video.pause());
            current?.remove();
          } else if (!current) {
            const next = template?.content.firstElementChild?.cloneNode(true);
            if (next) this.insertBefore(next, template);
          }
        }, { signal: this.events.signal });
        return;
      }
      if (this.hasAttribute('data-routine-model-media')) {
        const productVariants = this.querySelector('[data-routine-product-variants]');
        try { this.productVariants = new Set(JSON.parse(productVariants?.textContent || '[]').map(String)); } catch (_) { return; }
        this.mediaTemplates = new Map([...this.querySelectorAll('template[data-routine-media-variant]')].map(template => [template.dataset.routineMediaVariant, template]));
        this.currentVariant = this.dataset.routineCurrentVariant;
        this.events = new AbortController();
        document.addEventListener('change', event => {
          if (!event.target.matches('form[id^="product-form-"] input[name="id"]')) return;
          const variant = String(event.target.value);
          // A different product's form/quick-add must not change this product's media.
          if (!this.productVariants.has(variant)) return;
          if (variant === this.currentVariant) return;
          this.currentVariant = variant;
          this.dataset.routineCurrentVariant = variant;
          const section = this.querySelector(':scope > section');
          const wrap = section?.querySelector('.stellar-editorial__wrap');
          const current = wrap?.querySelector(':scope > .stellar-editorial__media');
          const template = this.mediaTemplates.get(variant);
          const replacement = template?.content.firstElementChild?.cloneNode(true);
          if (!section || !wrap) return;
          // Pause before disconnecting; the motion element owns its own cleanup.
          current?.querySelectorAll('video').forEach(video => video.pause());
          if (!replacement) {
            current?.remove();
            section.hidden = true;
            return;
          }
          if (current) current.replaceWith(replacement);
          else wrap.insertBefore(replacement, wrap.querySelector(':scope > .stellar-editorial__copy'));
          section.classList.toggle('stellar-editorial--motion', replacement.classList.contains('stellar-editorial__media--motion'));
          section.hidden = false;
        }, { signal: this.events.signal });
        return;
      }
      const data = this.querySelector('[data-routine-variants]');
      if (!data) return;
      try { this.images = JSON.parse(data.textContent); } catch (_) { return; }
      this.events = new AbortController();
      document.addEventListener('change', event => {
        if (!event.target.matches('form[id^="product-form-"] input[name="id"]')) return;
        const next = this.images[event.target.value], image = this.querySelector('.stellar-editorial__image');
        if (!next || !image) return;
        image.srcset = next.srcset;
        image.src = next.src;
        image.alt = next.alt;
      }, { signal: this.events.signal });
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; }
  });
})();
